module.exports = __webpack_public_path__ + "img/element.30c068b4.png";